import { call } from './apiHelpers';

export const campaignService = {
  getActive: () => call('get', 'campaigns/active/'),
};
